// extracted by mini-css-extract-plugin
export var active = "_ma-2";
export var recordingDot = "_ma-1";
export var recordingIndicator = "_ma-0";